import Medallia from './Medallia';
import { withMedalliaProps } from 'viewModel/medallia/withMedalliaProps';

export default withMedalliaProps(Medallia);
